"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.ListCardCopyWrap = exports.CardListTitle = exports.BookmarkDesktop = exports.CardDescription = exports.CardSubtitle = exports.ListCardLabel = exports.ListCardFlex = exports.ListCardContent = exports.ListCardImage = exports.CardListContainer = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _rebass = require("rebass");

var _Media = _interopRequireDefault(require("../../Media"));

var _Card = require("./Card.style");

var _mediaQueries = _interopRequireDefault(require("../../../styles/mediaQueries"));

var _Typography = require("../../Typography");

var _Bookmark = _interopRequireDefault(require("../../Bookmark"));

var cardListTextWidth = function cardListTextWidth(bookmark) {
  return bookmark ? 'calc(100% - 5.5rem)' : 'auto';
};

var CardListContainer = (0, _styled.default)('div')(_defineProperty({
  height: '100%'
}, _mediaQueries.default.medium, {
  display: 'flex',
  alignItems: 'stretch'
}));
exports.CardListContainer = CardListContainer;
var ListCardImage = (0, _styled.default)(_Media.default)({
  display: 'block',
  height: '100%',
  paddingBottom: '56.25%',
  width: '100%'
});
exports.ListCardImage = ListCardImage;
var ListCardContent = (0, _styled.default)(_rebass.Flex)(function (_ref2) {
  var _ref2$theme = _ref2.theme,
      colors = _ref2$theme.colors,
      cards = _ref2$theme.cards,
      space = _ref2$theme.space,
      image = _ref2.image;
  return _defineProperty({
    height: '100%',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: space.base,
    backgroundColor: colors[cards.contentBgColor],
    color: colors[cards.contentTextColor],
    border: image ? '0' : "".concat(cards.textOnlyBorder, " ").concat(colors[cards.textOnlyBorderColor]),
    borderTop: image ? '0' : "".concat(cards.borderTop, " ").concat(colors[cards.borderTopColor])
  }, _mediaQueries.default.large, {
    paddingLeft: space.xlarge
  });
});
exports.ListCardContent = ListCardContent;
var ListCardFlex = (0, _styled.default)(_rebass.Flex)(function (_ref4) {
  var space = _ref4.theme.space,
      hasCta = _ref4.hasCta;
  return _defineProperty({
    alignItems: 'center',
    justifyContent: hasCta ? 'space-between' : 'flex-start',
    marginTop: space.medium
  }, _mediaQueries.default.large, {
    marginTop: space.base
  });
});
exports.ListCardFlex = ListCardFlex;
var ListCardLabel = (0, _styled.default)(_Typography.Body)(function (_ref6) {
  var colors = _ref6.theme.colors;
  return {
    color: colors.offblack,
    fontWeight: 'bold'
  };
});
exports.ListCardLabel = ListCardLabel;
var CardSubtitle = (0, _styled.default)(_Typography.Body)(function (_ref7) {
  var space = _ref7.theme.space,
      bookmark = _ref7.bookmark;
  return _defineProperty({
    marginBottom: space.xxsmall,
    fontWeight: 'bold'
  }, _mediaQueries.default.medium, {
    width: cardListTextWidth(bookmark)
  });
});
exports.CardSubtitle = CardSubtitle;
var CardDescription = (0, _styled.default)(_Typography.Body)(function (_ref9) {
  var space = _ref9.theme.space,
      bookmark = _ref9.bookmark;
  return _defineProperty({
    marginTop: space.xsmall
  }, _mediaQueries.default.medium, {
    width: cardListTextWidth(bookmark)
  });
});
exports.CardDescription = CardDescription;
var BookmarkDesktop = (0, _styled.default)(_Bookmark.default)(function (_ref11) {
  var space = _ref11.theme.space;
  return {
    position: 'absolute',
    top: space.small,
    right: space.base,
    zIndex: 1
  };
});
exports.BookmarkDesktop = BookmarkDesktop;
var CardListTitle = (0, _styled.default)(_Card.CardTitle)(function (_ref12) {
  var space = _ref12.theme.space,
      bookmark = _ref12.bookmark,
      hasTag = _ref12.hasTag;
  return _defineProperty({
    display: 'block',
    marginTop: hasTag ? space.small : 0
  }, _mediaQueries.default.medium, {
    width: cardListTextWidth(bookmark)
  });
});
exports.CardListTitle = CardListTitle;
var ListCardCopyWrap = (0, _styled.default)(_Typography.Body)(function (_ref14) {
  var _ref15;

  var _ref14$theme = _ref14.theme,
      space = _ref14$theme.space,
      colors = _ref14$theme.colors,
      bookmark = _ref14.bookmark;
  return _ref15 = {
    color: colors.offblack,
    paddingTop: space.small
  }, _defineProperty(_ref15, _mediaQueries.default.medium, {
    width: cardListTextWidth(bookmark)
  }), _defineProperty(_ref15, "p", {
    marginBottom: 0
  }), _ref15;
});
exports.ListCardCopyWrap = ListCardCopyWrap;